import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit, OnChanges } from '@angular/core';
import { IAttachmentDTO, IAttachmentsFormItemDetails } from '../utils/interfaces';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ComponentPrototype } from '../../../../abstract';

@Component({
  selector: 'app-attachments-form-editor',
  template: `
    <form class="attachments-form__editor" [formGroup]="form">
      <input class="form-control" type="text" placeholder="Title" formControlName="title" />
      <div class="form-indent"></div>
      <app-rich-text-editor [formControl]="form.get('description')"></app-rich-text-editor>
    </form>
  `,
  styleUrls: ['../styles/attachments-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsFormEditorComponent extends ComponentPrototype implements OnInit, OnChanges {
  @Input() public model: Partial<IAttachmentDTO>;

  @Input() public titlePlaceholder: string = 'Title (optional)';

  @Input() public descriptionPlaceholder: string = 'Description (optional)';

  @Input() public disabled: boolean = false;

  @Output() public valueChange: EventEmitter<IAttachmentsFormItemDetails> =
    new EventEmitter<IAttachmentsFormItemDetails>();

  public form: UntypedFormGroup;

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      title: new UntypedFormControl(this.model?.title || ''),
      description: new UntypedFormControl(this.model?.description || ''),
    });

    this.registerSubscriptions(this.form.valueChanges.subscribe(formValue => this.valueChange.emit(formValue)));
  }

  ngOnChanges(): void {
    this.disabled ? this.form?.disable({ emitEvent: false }) : this.form?.enable({ emitEvent: false });
  }
}
